import styled, { css } from 'styled-components'
import { maxWidth, noTouch } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'
import Social from './StyledSocial'
import Container from './StyledContainer'

const Footer = styled.footer`
  color: var(--color-light);
  background: #333;
  ${maxWidth(vars.breakpoints.tablet)`
    margin-top:60px;
  `}

  ${(props) =>
    props.stretch &&
    css`
      flex: 1 0 auto;
      display:flex;
      flex-direction:column;
      ${Footer.Main} {
        flex: 100%;
      }
    `}

  ${(props) =>
    props.hideMargin &&
    css`
      ${maxWidth(vars.breakpoints.tablet)`
        margin-top:0;
      `}
    `}
  
`

Footer.Main = styled.div`
  display: grid;
  grid-template-columns: 48.1% 1fr;
  align-items: stretch;

  ${maxWidth(vars.breakpoints.tablet)`
    grid-template-columns: 1fr;
  `}

   ${(props) =>
    props.hiddenBlock &&
    css`
      display:none;
    `}
`

Footer.Data = styled.div`
  padding: 100px 64px 72px 60px;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 60px 20px 53px;
  `}
`

Footer.Map = styled.div`
  width:100%;
  overflow:hidden;
`
Footer.Block = styled.div``



Footer.Title = styled.h2`
  font-weight: 400;
  font-size: 24px;
  line-height:1.2;
  text-transform: uppercase;
  color: var(--color-decor);
  margin-bottom: 30px;
`

Footer.List = styled.ul`
  display:flex;
  flex-direction:column;
  gap:15px;
  margin-bottom: 20px;
`

Footer.Item = styled.li`
  display: flex;
  align-items:flex-start;
  gap:15px;
`

Footer.Link = styled.a`
  display: flex;
  font-size: 16px;
  line-height: 150%;
  color: #f8f8f8;
  transition: opacity 0.3s ease-out;

  ${(props) =>
    props.active &&
    css`
      opacity: 0.55;
      text-shadow: 0.5px 0 0 currentColor;
    `}

  ${noTouch()`
    &:hover {
      opacity: ${(props) => !props.noHover && !props.active && 0.7};
    }
  `}
`

Footer.Logo = styled.div`
  margin-right: 16px;

  svg {
    ${maxWidth(vars.breakpoints.tablet)`
      width: 135px;
      height: 40px;
    `}
  }
`

Footer.SocialList = styled.div`
  display: flex;
  gap:15px;
  justify-content: flex-start;

  ${Social} {
    --social-bg-color: transparent;
    --social-border-color: var(--color-decor);
    --social-width: 32px;
    --social-height: 32px;
    color:var(--color-decor);

    ${maxWidth(vars.breakpoints.tablet)`
      --social-width: 30px;
      --social-height: 30px;
    `}
  }
`
Footer.Image = styled.div`
  display:flex;
  width: 239px;
  height: 65px;
  margin: 102px 0 0 auto;
    ${maxWidth(vars.breakpoints.tablet)`
      margin: 44px 0 0 auto;
    `}
`

Footer.Bottom = styled.div`
  padding: 30px 0;
  background: var(--color-decor, #b69b64);
  position:relative;
  z-index:1;

  & > ${Container} {
    display: flex;
    flex-wrap:wrap;
    justify-content:center;
    align-items: center;
    column-gap:60px;
    row-gap: 10px;

    ${maxWidth(vars.breakpoints.tablet)`
      flex-direction:column;
      align-items:flex-start;
      row-gap:1px;
    `}
  }

  ${maxWidth(vars.breakpoints.mTablet)`
    padding: 20px 0;
  `}
`


Footer.LegalLink = styled.a`
  transition: opacity 0.3s ease-out;

  ${noTouch()`
    &:hover {
      opacity: 0.5;
    }
  `}
`

Footer.Text = styled.span`
  display:flex;
  align-items:center;
  gap:60px;
  font-weight: 400;
  font-size: 13px;
  line-height: 123%;
  color: #fff;
  &:not(:last-child):after {
    content: '';
    display:block;
    width:4px;
    height:4px;
    border-radius:50px;
    background:#fff;
    opacity:0.3;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    &:nth-child(n):after {
      display:none;
    }

    ${(props) =>
      props.mid &&
      css`
        font-size: 15px;
      `}
  `}

  ${maxWidth(vars.breakpoints.mTablet)`
    line-height: 138%;
  `}
`

export default Footer
